import { emailRegex, passwordRegex, USER_DEACTIVATED_BY_ADMIN } from "./constants";
// backend validation error messages mapping ,
// add backend error messages to the ist ENABLE_ANALYZER



const responseErrorMapping = (error) => {

    const errorMappingList = {

        // Login API Errors
        'Incorrect email or password!': 'Incorrect email or password!',
        'Incorrect email': 'Formated email',
        'No Kitchen serving to this zipcode': `We're sorry! Service in your area is not yet available`,
        'User donst not exist': 'No delivery address found',
        'Inactive by admin': 'Account deactivated, Contact support',
        'user authentication is with gmail or facebook': 'Login with gmail or facebook',
        'Email address already exist please login!': 'Email already exists. Please log in!',
        'A serious error occurred. Please contact support. REF# 667789': 'A serious error occurred. Please contact support. REF# 667789',
        'User does not exist': 'The user was not found.',
        'Gmail authentication failed': 'Gmail authentication failed.',



        //OTP Verify Token REACT_APP_API_URL
        'OTP  Expired': 'Token expired',
        'Invalid OTP Token': 'Invalid token',
        'There is no user with that email': 'No user found with that email address',
        'Email and OTO token is required': 'OTP Token is required',
        'OTP Verified': 'Email verified successfully',
        'User does not exists in our stripe collection records!': 'User not found. Please sign in again or contact support for help.',


        // Checkout Page
        'Customer card is declined && Zero Plates Available': 'Card failed please update card, 0 Subscription plate available',
        'Network Error': 'Somthing went wrong please try again later',
        'Please enter future time slot, entered time slot is of past time': 'Delivery time slot cannot be in past',
        'Card Declined': 'Card failed Please update card',
        'Stripe card declined': 'Card declined. Please update your card or check with your bank',
        'Discount coupon code is not valid!': 'Invalid discount code',
        'Invalid coupon, branch does not exist': 'Invalid discount code or discontinued due to limit',
        'Invalid coupon, kitchen does not exist in this branch': 'Invalid discount code or discontinued due to issue with promotion',
        'Invalid coupon': 'Invalid discount code',
        'Discount code exceeded usage limit': 'Discount code limit exceeded',
        'Check Discount code start date': 'Please check discount code start date',
        'invalid discount code': 'Promo code expired',
        'invalid discount code, not applicable for delivery type pickup': 'Discount code not applicable for pickup orders',
        'Customer status Card decline': 'Card declined. Please update your card or check with your bank',
        'Please enter a future delivery date for promotional order': 'Promo order Delivery date cannot be in past',
        'Please enter future time slot for promotional order delivery, entered time slot is of past time': 'Promo order Delivery time slot cannot be in past',
        'Sorry Promotional item is out of stock ref-12': 'Sorry promotional item out of stock',
        'Sorry Promotional item is out of stock ref-1122': 'Sorry promotional item out of stock',
        'Sorry Promotional item is out of stock ref-3344': 'Sorry promotional item out of stock',
        'Sorry Promotional item is out of stock ref-5050': 'Sorry promotional item out of stock',
        'Promotion Kitchen is invalid.': 'Promotional kitchen is closed contact help desk ref-2299',
        'User does not exists in our stripe records!': 'Payment failed. Please update your card information.',



        // Promo code 
        'invalid discount code check end date': 'Promotion expired',
        'Sorry delivery discount code, not applicable for meal order joined': 'Discount code not applicable with meal order',
        'Invalid discount code': 'Invalid discount code',
        'Sorry FREE order code, cannot be applied with meal order': 'FREE code not valid on meal orders.',
        'Sorry promo code, not applicable for combined orders': 'Promo code not applicable with combined orders',
        'invalid discount code expired': 'Discount code expired',
        'Discount code is only for new customer': 'Discount code is only for new customer',


        //susbcription promo code validation

        'Invalid discount code': 'Invalid discount code',
        'Invalid discount code. This code is not valid in your region': 'Code is not valid in your region',
        "Invalid meal plan ID. Please check the ID and try again": 'Invalid discount code',
        "Invalid discount code. Please check the start date": "Please check the start date",
        "Invalid discount code. Please check the end date": "Please check the end date",
        "Discount code is only for new customer": "Oops! This discount is just for new customers",



        // Delivery slot 
        'Sorry, but it seems that there are no delivery slots available for today.': 'Sorry no delivery slots available for today',

        // Forgot password
        'Something is seriouly wrong,This is last CATCH block': 'Something is seriously wrong, please notify IT support #Ref 30919',

        //Reset password
        'Token Expired': 'Token is expired',
        'Invalid token in side body': 'Invalid reset token',
        'Password and retype password dont match!': 'Password and retype password dont match!',
        'Password update successfully!': 'Password update successfully!'


    }

    return errorMappingList[error] || error

}

export default responseErrorMapping
